module.exports = __webpack_public_path__ + "acbf111fea2f9e8709d9195813b30ef7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/mustache-chef-s.png
// module id = 1821
// module chunks = 0